// event 模块 url 地址管理
export const url = {
  getListData: '/auth/event/viewAll',
  getLastUpdateTime: '/auth/event/lastUpdateTime',
  getDetail: '/auth/event/info',
  getConceptList: '/auth/event/conceptList',
  getTrendList: '/auth/event/trendList',
  getBasfProductSegment: '/auth/event/tradeNameSegment',
  getFormulationSegment: '/auth/event/formulationSegment',
  getFormulationList: '/auth/event/formulationList',
  getBasfProductList: '/auth/event/tradeNameList',
  setComment: '/auth/event/comment/save',
  getKeywordList: '/auth/event/keyWordList'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/eventClient.js